import { ComponentProps } from 'react';
import { SideMenuFooter } from './SideMenuFooter';
import { SideMenuHeader } from './SideMenuHeader';
import { SideMenuNavigation } from './SideMenuNavigation';
import styles from './styles.module.scss';

type SideMenu = ComponentProps<typeof SideMenuNavigation>['menus'];

type Props = {
  imageUrl: string;
  url?: string;
  menus: SideMenu;
  displayName: string;
  signOut: () => void;
  children?: React.ReactNode;
};

/**
 * サイドメニュー
 *
 * @param param0
 * @returns
 */
export const SideMenu: React.FC<Props> = ({
  imageUrl,
  url,
  menus,
  displayName,
  signOut,
  children,
}) => (
  <div className={styles.SideMenu}>
    <SideMenuHeader imageUrl={imageUrl} url={url} />
    <SideMenuNavigation menus={menus} />
    <SideMenuFooter displayName={displayName} signOut={signOut}>
      {children}
    </SideMenuFooter>
  </div>
);
